import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { DisplayText } from '../display-text/display-text';
import { Icon } from '../icon/icon';
import { LoadingIndicatorType } from './types/type';
const b = bemClassBuilder('v-loading-indicator');
export const LoadingIndicator = observer(props => {
    const { className, type } = props;
    return _jsx("div", Object.assign({ className: b.block({ type }, className) }, { children: getContents(props) }));
});
LoadingIndicator.displayName = 'LoadingIndicator';
const getContents = (props) => {
    if (props.type === LoadingIndicatorType.Horizontal) {
        return _jsx("div", { className: b.element('foreground') });
    }
    if (props.type === LoadingIndicatorType.Spinner) {
        const { iconName, message } = props;
        return (_jsxs(_Fragment, { children: [_jsx(Icon, { className: b.element('icon'), name: iconName }), message && _jsx(DisplayText, { className: b.element('message'), label: message })] }));
    }
    throw new Error('Invalid loading indicator properties.');
};
